import React from "react";
import VerificationInput from "react-verification-input";
import { useTranslation } from "@/hooks/useTranslation";

import { cn } from "@/lib/utils";
import FluidImage from "../images/fluid-image";
import { FLUID_CDN_URL } from "@/lib/constants";

export default function VerificationDialog({
  setOpenDialog,
  verificationCodeError,
  onComplete,
  email,
  isPending,
}: {
  setOpenDialog: (open: boolean) => void;
  verificationCodeError: string | undefined;
  onComplete: (code: string) => void;
  email: string;
  isPending: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div
      className={"relative mt-4 rounded border border-gray-300 p-4 shadow-xs"}
    >
      <div className="absolute top-1 right-3">
        <button onClick={() => setOpenDialog(false)}>
          <FluidImage
            src={`${FLUID_CDN_URL}/images/checkout/icons/x.svg`}
            alt="Close"
            width={8}
            height={8}
          />
        </button>
      </div>
      <div className="w-full text-center text-sm font-medium text-gray-900">
        {t("confirm_its_you")}
      </div>
      <div className="flex flex-col items-center">
        <div className="text-center text-sm text-gray-400">
          {`${t("enter_the_code_sent_to")} ${email} ${t(
            "checkout_securely_using_your_saved_information",
          )}`}
        </div>
        <VerificationInput
          length={6}
          classNames={{
            character: cn(
              "flex items-center justify-center rounded border border-gray-300 p-2 text-lg",
              {
                "border-red-500": verificationCodeError,
              },
            ),
            container: "my-2 px-2",
            characterInactive: "bg-white",
          }}
          onComplete={onComplete}
        />
        {isPending && (
          <div className="mr-3 mb-2 h-5 w-5 animate-spin rounded-full border-4 border-t-4 border-gray-300 border-t-transparent" />
        )}
        {verificationCodeError && !isPending && (
          <div className="mb-2 text-center text-sm text-red-500">
            {verificationCodeError}
          </div>
        )}
      </div>
    </div>
  );
}
